// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"400":"2dc79d8145a3ae51","722":"638c56303493f66f"}[chunkId] + ".js";
};